// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoLe_Ak_uWST4WWyZRUk {
  max-width: 600px;
  margin: 8px auto 0;

  padding-bottom: 2em;
}

.cNEPSdMjTRMgob92z3KT {
  margin: 30px 0 0;
}

.wtC1XtmicbVR1VGtADxI {
  font-size: 38px;
  line-height: 1.2;
  color: #30b5c7;
  font-weight: 400;
  text-align: center;
}

.kg5IoTfYWGycCPKoP4yV {
  font-size: 34px;
  color: #30b5c7;
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
}

.xiEWrzA9FmECNYJl0sCa {
  font-size: 25px;
  color: #30b5c7;
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
}

.K9Fa_BY9UVThiEEQphGU {
  font-size: 18px;
  line-height: 1.42;
  margin: 0 auto 40px;
}

.fRNmqGrTmXb9_SvZ6H55 {
  margin: 11px auto 10px;
  line-height: 1.3;
}`, "",{"version":3,"sources":["webpack://./src/pages/link-app/link-app.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":[".container {\n  max-width: 600px;\n  margin: 8px auto 0;\n\n  padding-bottom: 2em;\n}\n\n.heading {\n  margin: 30px 0 0;\n}\n\n.h1 {\n  font-size: 38px;\n  line-height: 1.2;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n}\n\n.h2 {\n  font-size: 34px;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.h3 {\n  font-size: 25px;\n  color: #30b5c7;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.largePara {\n  font-size: 18px;\n  line-height: 1.42;\n  margin: 0 auto 40px;\n}\n\n.emailLink {\n  margin: 11px auto 10px;\n  line-height: 1.3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoLe_Ak_uWST4WWyZRUk`,
	"heading": `cNEPSdMjTRMgob92z3KT`,
	"h1": `wtC1XtmicbVR1VGtADxI`,
	"h2": `kg5IoTfYWGycCPKoP4yV`,
	"h3": `xiEWrzA9FmECNYJl0sCa`,
	"largePara": `K9Fa_BY9UVThiEEQphGU`,
	"emailLink": `fRNmqGrTmXb9_SvZ6H55`
};
export default ___CSS_LOADER_EXPORT___;
